import React, { use, useEffect, useState } from "react";
import axios from "axios";
import { set, useForm } from "react-hook-form";
import { useOutletContext, useNavigate } from "react-router-dom";
import $ from "jquery";
import { Client_View } from "../../../utils/sweetalert";
import toastr from "../../../utils/toast";
import Select from "react-select";
import { useRef } from "react";

function CloseProspect({ onClose, company_id }) {
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const [data, setData] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [countries, setCountries] = useState([]);
  const [majorIndustries, setMajorIndustries] = useState([]);
  const [minorIndustries, setMinorIndustries] = useState([]);
  const [users, setUsers] = useState([]);
  const [companyinfos, setcompanyinfos] = useState([]);
  const [peVcReferred, setpeVcReferred] = useState([]);
  const [showOthergroupedCompany, setshowOthergroupedCompany] = useState(false);
  const [activeUsers, setActiveUsers] = useState([]);
  const [pipelineStatus, setPipelineStatus] = useState([]);
  const [pevcOptions, setPevcOptions] = useState([]);
  const [selectedPevc, setSelectedPevc] = useState(null);

  const searchTimeout = useRef(null);

  const groupedCompanyOption = watch("groupedCompanyOption");

  // Fetch dropdown data once on mount

  async function fetchAllDropdownData() {
    setGlobalLoading(false); //  Show loader before API call
    try {
      const res = await axios.get(`${API_BASE_URL}/clients/clientd`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = res.data;
      setData(data);
      setCompanies(data.companies || []);
      setCountries(data.countries || []);
      setMajorIndustries(data.majorIndustry || []);
      setUsers(data.users || []);
      setValue("reference", data.new_reference || "");
    } catch (error) {
      console.error("Error fetching form data:", error);
    }
  }

  async function getActiveUser() {
    const res = await axios.get(`${API_BASE_URL}/employeeinfos/getActiveUser`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = res.data.options;
    setActiveUsers(data);
  }

  async function getPipeLineStatus() {
    const res = await axios.get(`${API_BASE_URL}/companyinfo/pipelinestatus`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = res.data.pipeline_status;
    console.log(data);
    setPipelineStatus(data);
  }

  useEffect(() => {
    fetchAllDropdownData();
    getActiveUser();
    getPipeLineStatus();
  }, [token, API_BASE_URL]);

  async function getPevcData(keyword) {
    const res = await axios.post(
      `${API_BASE_URL}/clients/companyInfoLoad`,
      {
        keywords: keyword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    let options = (res.data.options || []).map((item) => ({
      value: item.value,
      label: item.label,
    }));

    const exactMatch = options.some(
      (item) => item.label.toLowerCase() === keyword.toLowerCase(),
    );

    if (!exactMatch && keyword.trim() !== "") {
      options.unshift({
        value: keyword,
        label: keyword,
        custom: true,
      });
    }

    setPevcOptions(options);
  }

  const clearSelect = () => {
    const $select = $('[name="companies"]');

    // Directly clear the field and options
    $select.find("option").remove(); // remove all options
    $select.val(null).trigger("change.select2"); // clear select2 display
    setValue("companies", ""); // clear react-hook-form value
    setcompanyinfos([]);
    setValue("industrymaster_id", "");
    setValue("industry_id", "");
  };

  const AlreadyExitClient = (id) => {
    Client_View({
      title: "",
      text: "This company is already a client",
      icon: "warning",
      confirmButtonText: "View Client",
      confirmCallback: () => ViewClient(id),
      cancleCallback: () => clearSelectedCompany(),
    });
  };

  const ViewClient = (id) => {
    onClose();
    setGlobalLoading(true);
    setTimeout(() => {
      navigate(`/client/view/${id}`);
    }, 1000);
  };

  const clearSelectedCompany = () => {
    clearSelect();
  };

  const get_pe_id_name = async (id) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/companyinfo/get_name_by_id/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data.companyinfo[0];

      if (data) {
        const option = {
          value: data.id,
          label: data.name,
        };

        setSelectedPevc(option);
        setPevcOptions([option]);

        setValue("companyinfo_id", data.id);
      }
    } catch (error) {
      toastr.error(error.message);
    }
  };

  useEffect(() => {
    if (!companyinfos) return;
    setValue("website", companyinfos.website);
    setValue("companies", companyinfos.name);
    setValue("company_id", companyinfos.id);
    setValue("gcc", companyinfos.gcc);
    const isPE = companyinfos.pe_id !== null;

    setValue("private_equity", isPE ? "yes" : "no");
    setpeVcReferredOption(isPE ? "yes" : "no");

    if (isPE && companyinfos.pe_id) {
      get_pe_id_name(companyinfos.pe_id); // ✅ important
    }

    setValue("bdInfluence", companyinfos.bdInfluence);
    const initIndustries = async () => {
      const major = majorIndustries.find(
        (m) => m.id === companyinfos.industrymaster_id,
      );
      if (major) {
        setValue("industrymaster_id", major.id || "");
        await fetchMinorIndustry({ target: { value: major.id } });
      }
    };
    initIndustries();
  }, [companyinfos, majorIndustries]);

  useEffect(() => {
    const minor = minorIndustries.find(
      (m) => m.id === companyinfos.industry_id,
    );
    if (minor) {
      setValue("industry_id", minor.id || "");
    }
  }, [minorIndustries]);

  const onSubmit = async (data) => {
    try {
      // setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/companyinfo/AddClient`,
        { data },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      toastr.success(response.data.message);
      onClose();
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error submitting form.");
    } finally {
      setGlobalLoading(false);
    }
  };

  // ############################################################

  const fetchMinorIndustry = async (e) => {
    const id = e.target.value;
    try {
      const response = await axios.get(
        `${API_BASE_URL}/common_controller/get_minor_industries_by_maji_id/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setMinorIndustries(response.data.minor_industries || []);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const setpeVcReferredOption = (e) => {
    const peVcReferredOption = e;
    setValue("private_equity", peVcReferredOption);
    setpeVcReferred(peVcReferredOption);
  };

  const showgroupedCompanyOther = (e) => {
    const groupedCompanyOther = e;
    console.log(groupedCompanyOther);
    if (groupedCompanyOther == 0) {
      setshowOthergroupedCompany(true);
    } else {
      setshowOthergroupedCompany(false);
    }
  };

  async function get_companyinfo_data() {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/companyinfo/get_companyinfo_details/${company_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const companyinfo = response.data.companyinfo[0];
      setcompanyinfos(companyinfo);
      console.log(companyinfo);
    } catch (error) {
      toastr.error(error.response.data.message);
    }
  }

  useEffect(() => {
    get_companyinfo_data();
  }, [company_id]);

  useEffect(() => {
    register("companyinfo_id", {
      required: peVcReferred === "yes" ? "required" : false,
    });
  }, [register, peVcReferred]);

  return (
    <div className="modal fade show d-block add_client" tabIndex="-1">
      <div
        className="modal-dialog modal-dialog-centered modal-md add_client_modal"
        role="document"
      >
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">
                Convert To Client
                <span style={{ marginLeft: "20px" }}>
                  <button type="button" className="btn btn-primary my-1 me-2">
                    Reference Id{" "}
                    <span className="badge ms-2 bg-secondary">
                      {data?.new_reference}
                    </span>
                  </button>
                </span>
              </h4>

              <button
                type="button"
                className="btn-close custom-btn-close"
                onClick={() => {
                  clearSelect();
                  onClose?.();
                }}
              >
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ padding: "30px" }}>
              <div className="col-xl-6">
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Company{" "}
                    <span className="text-danger">
                      * {errors.companies && errors.companies.message}
                    </span>
                  </label>
                  <input type="hidden" {...register("reference")} />
                  <input
                    type="text"
                    {...register("companies", { required: "required" })}
                    className="form-control"
                    readOnly={true}
                  />
                  <input type="hidden" {...register("company_id")} />
                </div>

                {/* Major Industry */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Major Industry{" "}
                    <span className="text-danger">
                      *{" "}
                      {errors.industrymaster_id &&
                        errors.industrymaster_id.message}
                    </span>
                  </label>
                  <select
                    {...register("industrymaster_id", {
                      required: "required",
                    })}
                    onChange={(e) => fetchMinorIndustry(e)}
                    className="form-select"
                  >
                    <option value="">Select</option>
                    {majorIndustries.map((m) => (
                      <option key={m.id} value={Number(m.id)}>
                        {m.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Global Capability Center (GCC){" "}
                    <span className="fs-8">[ e.g. Is this a part of GCC]</span>
                  </label>
                  <select
                    {...register("gcc", { value: "no" })}
                    className="form-select"
                  >
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>

                {/* Grouped Company Option */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Is part of a parent group of companies?
                    <span className="text-danger">
                      {" "}
                      *{" "}
                      {errors.groupedCompanyOption &&
                        errors.groupedCompanyOption.message}
                    </span>
                  </label>
                  <select
                    {...register("groupedCompanyOption", {
                      required: "required",
                    })}
                    className="form-select"
                  >
                    <option value="no">No</option>
                    <option value="yes">Yes</option>
                  </select>
                  {groupedCompanyOption === "yes" && (
                    <>
                      {errors.groupedCompany && (
                        <span className="text-danger">
                          {errors.groupedCompany.message}
                        </span>
                      )}
                      <select
                        {...register("groupedCompany", {
                          required: "required",
                        })}
                        onChange={(e) =>
                          showgroupedCompanyOther(e.target.value)
                        }
                        className="form-select mt-2"
                      >
                        <option value="">Select</option>
                        {companies.map((c) => (
                          <option key={c.id} value={Number(c.id)}>
                            {c.name}
                          </option>
                        ))}
                        <option value={0}>other</option>
                      </select>
                      {showOthergroupedCompany && (
                        <>
                          <span>
                            {errors.groupedCompanyOther && (
                              <span className="text-danger">
                                {errors.groupedCompanyOther.message}
                              </span>
                            )}
                          </span>
                          <input
                            type="text"
                            {...register("groupedCompanyOther", {
                              required: "required",
                            })}
                            placeholder="Enter Grouped Company Name"
                            className="form-control mt-2"
                          />
                        </>
                      )}
                    </>
                  )}
                </div>

                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Business Developed By
                    <span className="text-danger">
                      {" "}
                      *{" "}
                      {errors.businessDeveloped_id &&
                        errors.businessDeveloped_id.message}
                    </span>
                  </label>
                  <select
                    {...register("businessDeveloped_id", {
                      required: "required",
                    })}
                    className="form-select"
                  >
                    <option value="">Select</option>
                    {users.length > 0 &&
                      users.map((item, index) => (
                        <option
                          key={index}
                          value={Number(item.id)}
                        >{`${item.firstname} ${item.lastname}`}</option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-xl-6">
                {/* Website */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Website{" "}
                    <span className="text-danger">
                      * {errors.website && errors.website.message}
                    </span>
                  </label>
                  <input
                    type="url"
                    {...register("website", {
                      required: "required",
                    })}
                    placeholder="https://www.example.com"
                    className="form-control"
                  />
                </div>
                {/* Minor Industry */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Minor Industry{" "}
                    <span className="text-danger">
                      * {errors.industry_id && errors.industry_id.message}
                    </span>
                  </label>
                  <select
                    {...register("industry_id", {
                      required: "required",
                    })}
                    className="form-select"
                    onChange={(e) => {
                      const value = e.target.value;
                      setValue("industry_id", value);
                    }}
                  >
                    <option value="">Select</option>
                    {minorIndustries.length > 0 &&
                      minorIndustries.map((m) => (
                        <option key={m.id} value={Number(m.id)}>
                          {m.name}
                        </option>
                      ))}
                  </select>
                </div>

                {/* PE/VC Referred Option */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    PE/VC Referred{" "}
                    <span className="text-danger">
                      * {errors.private_equity && errors.private_equity.message}
                    </span>
                  </label>
                  <select
                    {...register("private_equity", {
                      required: "required",
                      value: "no",
                    })}
                    onChange={(e) => setpeVcReferredOption(e.target.value)}
                    className="form-select"
                  >
                    <option value="no">No</option>
                    <option value="yes">Yes</option>
                  </select>
                  {peVcReferred === "yes" && (
                    <span className="mt-2" style={{ padding: "0" }}>
                      {errors.peVcReferred && (
                        <span className="text-danger">
                          {errors.peVcReferred.message}
                        </span>
                      )}
                      <Select
                        className="mt-2"
                        options={pevcOptions}
                        value={selectedPevc}
                        onChange={(option) => {
                          setSelectedPevc(option);

                          if (option?.custom) {
                            setValue("companyinfo_id", option.label, {
                              shouldValidate: true,
                            });
                          } else {
                            setValue("companyinfo_id", option?.value || "", {
                              shouldValidate: true,
                            });
                          }
                        }}
                        onInputChange={(value, actionMeta) => {
                          if (actionMeta.action === "input-change") {
                            if (searchTimeout.current) {
                              clearTimeout(searchTimeout.current);
                            }

                            searchTimeout.current = setTimeout(() => {
                              if (value.trim() !== "") {
                                getPevcData(value.trim());
                              }
                            }, 500);
                          }
                        }}
                        placeholder="Search PE/VC"
                        isClearable
                      />
                    </span>
                  )}
                </div>

                {/* Client Managed By */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Client Managed By
                    <span className="text-danger">
                      {" "}
                      *{" "}
                      {errors.clientManaged_id &&
                        errors.clientManaged_id.message}
                    </span>
                  </label>
                  <select
                    {...register("clientManaged_id", {
                      required: "required",
                    })}
                    className="form-select"
                  >
                    <option value="">Select</option>
                    {users.length > 0 &&
                      users.map((item, index) => (
                        <option
                          key={index}
                          value={Number(item.id)}
                        >{`${item.firstname} ${item.lastname}`}</option>
                      ))}
                  </select>
                </div>
                {/* BD Influence */}
                <div className="row mb-3 me-3">
                  <label className="form-label">BD Influence</label>
                  <select {...register("bdInfluence")} className="form-select">
                    <option value="">Select</option>
                    {users.length > 0 &&
                      users.map((item, index) => (
                        <option
                          key={index}
                          value={Number(item.id)}
                        >{`${item.firstname} ${item.lastname}`}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="modal-footer" style={{ justifyContent: "center" }}>
              <button type="submit" className="btn btn-primary me-2">
                Save Client
              </button>

              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  clearSelect();
                  onClose?.();
                }}
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CloseProspect;
